import { FileDoneOutlined, RedoOutlined, DeleteOutlined, EditOutlined, HolderOutlined } from "@ant-design/icons";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Card, Col, Flex, Row, Typography, Pagination, Checkbox, Table, Space, Tooltip, Divider } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, useWatch, useFormContext } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import * as yup from "yup";
import PageHeader from "../../view/pageheader";
import DateInput from "../CustomComponents/DateInput";
import SelectInput from "../CustomComponents/SelectInput";
import TextAreaInput from "../CustomComponents/TextAreaInput";
import TextInput from "../CustomComponents/TextInput";
import { getUserManagementList } from "../../store/reducer/userManagementSlice";
import { getCustomerList } from "../../store/reducer/customerSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SearchComponent from "../CustomComponents/SearchComponent";
import { getEventList } from "../../store/reducer/eventSlice";
import {
  addJob,
  updateJob,
  resetSuccessFlag,
  getJobByID,
} from "../../store/reducer/jobSlice";
import { getWorkFlowList } from "../../store/reducer/workflowSlice";
import dayjs from "dayjs";
import DateTimeInput from "../CustomComponents/DateTimeInput";
import Loader from "../../fields/Loader/Loader";
import { debounce } from "lodash";
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, arrayMove, useSortable } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import Swal from "sweetalert2";
import { CSS } from "@dnd-kit/utilities";
const AddEditJobs = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [type, setType] = useState("add");
  const [jobId, setJobId] = useState(null);
  const [managerData, setManagerData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [workflowData, setWorkflowData] = useState([]);
  const [, setJobData] = useState({});
  const [showEvents, setShowEvents] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [eventData, setEventData] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [highlightedEvents, setHighlightedEvents] = useState([]);
  // Selectors
  const {
    addJobSuccess,
    updateJobSuccess,
    addJobError,
    addJobErrorMessage,
    jobListByIdData,
    updateJobErrorMessage,
    updateJobError,
    jobLoading
  } = useSelector((state) => state.jobs);
  // Form Validation Rules using Yup
  const validationRules = yup.object().shape({
    customer_id: yup
      .number()
      .typeError("Please select a valid customer")
      .required("Customer is required"),
    workflow_id: yup
      .number()
      .typeError("Please select a valid customer")
      .notRequired(),
    job_name: yup.string().trim().required("Job name is required"),
    address: yup.string().trim().typeError("Address is required").notRequired(),
    aisle: yup.string().trim().typeError("Aisle is required").notRequired(),
    level: yup.string().trim().typeError("Level is required").notRequired(),
    bay: yup.string().trim().typeError("Bay or Shelf is required").notRequired(),
    status: yup
      .number()
      .typeError("Please select a valid status")
      .required("Status is required"),
    // from: yup.string().trim().typeError("From is required").notRequired(),
    to: yup
      .number()
      .typeError("Please select a valid project manager")
      .notRequired(),
    // pickup_date: yup.date().typeError("Pickup date is required").notRequired(),
    original_disposition: yup
      .number()
      .typeError("Please select a valid original disposition")
      .notRequired(),
    disposition_day: yup.number().typeError("Please select a valid  number").notRequired(),
    left_warehouse: yup.date().typeError("Left warehouse is required").notRequired(),
    spec_id: yup
      .string()
      .matches(/^\d{5}$/, "Spec ID must be exactly 5 digits")
      .required("Spec ID is required"),
    event_id: yup.array().notRequired(),
    delivery_type: yup
      .number()
      .typeError("Please select a valid Delivery Type")
      .required('Please select a valid Delivery Type'),

  });
  const { userManagementListData } = useSelector(
    (state) => state.userManagement
  );
  const { eventListData } = useSelector((state) => state.events);
  const { workflowListData } = useSelector((state) => state.workflow);
  const { customerListData } = useSelector((state) => state.customers);
  function getDatas(payload = {}) {
    dispatch(getCustomerList(payload));
    dispatch(getWorkFlowList(payload));
    dispatch(getEventList(payload));
  }
  useEffect(() => {
    getDatas({});
  }, []);
  useEffect(() => {
    if (customerListData?.data) {
      setCustomerData(customerListData?.data);
    }
    if (eventListData?.data) {
      setEventData(eventListData.data);
    }
  }, [customerListData, eventListData]);
  useEffect(() => {
    if (workflowListData?.data) {
      setWorkflowData(workflowListData?.data);
    }
  }, [workflowListData])
  const workflowList = useMemo(() => {
    return workflowData?.filter((item) => item.status == 1).map((data) => {
      return {
        label: data.workflow_name,
        value: data.id,
      };
    })
  }, [workflowData])

  const customerList = useMemo(() => {
    return customerData
      .filter((item) => item?.status === 1)
      .map((item) => ({
        label: item.customername,
        value: item.id,
      }));
  }, [managerData]);
  function getDataProjectManager(payload = {}) {
    dispatch(getUserManagementList(payload));
  }
  const handleSearch = debounce((query) => {
    const payloadData = { query };
    dispatch(getEventList(payloadData));
  }, 300);
  const handleShowEvents = () => {
    setShowEvents(prev => !prev); // Step 2: Toggle the state to show/hide events
  };
  useEffect(() => {
    getDataProjectManager();
  }, []);
  useEffect(() => {
    if (userManagementListData?.data) {
      setManagerData(userManagementListData?.data);
    }
  }, [userManagementListData]);
  const managerList = useMemo(() => {
    return managerData
      .filter((item) => item.role_id === 2 && item.status === 1)
      .map((item) => ({
        label: item.user_name,
        value: item.id,
      }));
  }, [managerData]);

  useEffect(() => {
    if (addJobSuccess) {
      toast.success("Job added successfully");
      dispatch(resetSuccessFlag({ flag: "addJobSuccess" }));
      { type == "add" && navigate("/jobs"); }
    }
    if (updateJobSuccess) {
      toast.success("Job updated successfully");
      dispatch(resetSuccessFlag({ flag: "updateJobSuccess" }));
      navigate("/jobs");
    }
    if (addJobError) {
      toast.error(addJobErrorMessage);
      dispatch(resetSuccessFlag({ flag: "addJobError" }));
    }
    if (updateJobError) {
      toast.error(updateJobErrorMessage);
      dispatch(resetSuccessFlag({ flag: "updateJobError" }));
    }
  }, [
    addJobSuccess,
    updateJobSuccess,
    addJobError,
    addJobErrorMessage,
    updateJobError,
    updateJobErrorMessage,
    dispatch,
    navigate,
  ]);

  useEffect(() => {
    if (jobListByIdData) {
      setJobData(jobListByIdData?.data);
    }
  }, [jobListByIdData]);
  const paginatedEvents = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return eventData.filter((data) => data?.status == 1).slice(startIndex, startIndex + pageSize);
  }, [eventData, currentPage, pageSize]);
  // Form hook setup
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues
  } = useForm({
    resolver: yupResolver(validationRules),
    defaultValues: {
      status: 2,
    },
    mode: "onChange",
  });
  const watchWorkflow = useWatch({ control, name: "workflow_id" })
  useEffect(() => {
    if (id) {
      let editId = atob(id);
      setType("edit");
      dispatch(getJobByID({ editId })); // Fetch job data for editing
    }
  }, [id, dispatch]);
  useEffect(() => {
    setValue("event_id", selectedEvents.map(event => event.id));
  }, [selectedEvents, setValue]);
  useEffect(() => {
    if (type === "edit" && jobListByIdData) {
      const formattedEvents = jobListByIdData?.data?.job_workflow?.map(event => ({
        id: event?.event_id,              // ID of the event
        eventname: event?.jobworkflow_event?.eventname, // Name of the event
        is_last_stage: event?.is_last_stage ? event?.is_last_stage : 0,
      })) || [];
      reset({
        ...jobListByIdData?.data,
        event_id: formattedEvents.map(event => event.id),
      });
      setSelectedEvents(formattedEvents);
    }
  }, [type, jobListByIdData, reset]);
  const onSubmit = (data) => {
    const payload = {
      ...data,
      workflow_events: selectedEvents.map((event, index) => ({ name: event?.eventname, id: event.id, serial_no: index + 1, user_group_id: event?.group_id, is_last_stage: event?.is_last_stage || 0 })),
    }
    const hasFinalStage = payload.workflow_events.some(
      (event) => Number(event.is_last_stage) == 1
    );

    if (payload.workflow_events.length && !hasFinalStage) {
      return toast.error("Please select one event as Final Stage");
    }

    // if (selectedEvents.length === 0) {
    //   return toast.error('Please select at least one event');
    // }
    if (type === "add") {
      dispatch(addJob({ postData: payload }));
    } else if (type === "edit") {
      const { job_workflow, ...data } = payload;
      let editId = atob(id);
      dispatch(updateJob({ postData: data, updateID: editId }));
    }
  };

  const CheckboxOnchange = (eventId, currentChecked) => {
    const isChecked = !currentChecked; // toggle the clicked one
    setSelectedEvents((prevEvents) =>
      prevEvents.map((event) => ({
        ...event,
        is_last_stage: event.id === eventId && isChecked ? 1 : 0,
      }))
    );
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };
  const handleEventSelect = (event) => {
    if (highlightedEvents.find((highlighted) => highlighted.id === event.id)) {
      setHighlightedEvents((prev) => prev.filter((e) => e.id !== event.id));
    } else {
      setHighlightedEvents((prev) => [...prev, event]);
    }
  };

  // const handleAddSelectedEvents = () => {
  //   if (highlightedEvents.length === 0) {
  //     return toast.error('Please select at least one event');
  //   }
  //   setSelectedEvents((prev) => [
  //     ...prev,
  //     ...highlightedEvents.filter(
  //       (highlighted) => !prev.find((selected) => selected.id == highlighted.id)
  //     ),
  //   ]);

  //   setHighlightedEvents([]);
  // };

  const handleAddSelectedEvents = () => {
    if (highlightedEvents.length === 0) {
      return toast.error('Please select at least one event');
    }

    setSelectedEvents((prev) => {
      // merge highlighted + prev
      let merged = [
        ...prev,
        ...highlightedEvents.filter(
          (highlighted) => !prev.find((selected) => selected.id == highlighted.id)
        ),
      ];

      // check if id=6 exists in merged
      const hasSix = merged.some((e) => e.id === 6);

      // enforce default selection if 6 exists and nothing else is marked as final
      if (hasSix && !merged.some((e) => e.is_last_stage === 1)) {
        merged = merged.map((e) => ({
          ...e,
          is_last_stage: e.id === 6 ? 1 : 0,
        }));
      }

      return merged;
    });

    setHighlightedEvents([]);
  };


  const handleEventRemove = (eventId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to remove this event?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setSelectedEvents(prevEvents => prevEvents.filter(event => event.id !== eventId));
        return toast.success('Event Removed successfully');
      }
    });
  };
  const handleJobSave = (eventId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Please Save the job before editing the event.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Save Job',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        const datas = getValues();
        if (!datas?.spec_id) {
          return toast.error("Please enter Spec ID before saving.");
        }
        const payload = {
          ...datas,
          workflow_events: selectedEvents.map((event, index) => ({ name: event?.eventname, id: event.id, serial_no: index + 1, user_group_id: event?.group_id })),
        }
        dispatch(addJob({ postData: payload })) // Save the job
          .then((response) => {
            // toast.success('Job saved successfully');
            setType("edit");
            setJobId(response.payload.data.id); // Set the job ID for editing
            navigate(`/events/edit/${window.btoa(eventId)}?type=evet_stage&job_id=${(window.btoa(response.payload.data.id))}`);
            // navigate(`/events/edit/${window.btoa(eventId)}?type=evet_stage&job_id=${(window.btoa(response.payload.data.id))}`);
          })
          .catch((err) => {
            // toast.error("Failed to save job");
          });
      }
    });
  };

  const handleReset = () => {
    reset();
  };
  const SortableRow = (props) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
      id: props["data-row-key"],
    });

    const style = {
      ...props.style,
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: "move",
    };

    return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
  };

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setSelectedEvents((prevState) => {
        const oldIndex = prevState.findIndex((item) => item?.id == active?.id);
        const newIndex = prevState.findIndex((item) => item?.id == over?.id);
        return arrayMove(prevState, oldIndex, newIndex);
      });
    }
  };

  const columns = [

    {
      title: "Sl.No",
      dataIndex: "workflow_id",
      key: "workflow_id",
      align: "center",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Event Name",
      dataIndex: "eventname",
      key: "eventname",
      align: "center",
      render: (text, data) => (
        <Typography.Link
          onMouseDown={() => {
            // if (type == "add") {
            //   navigate(`/events/edit/${window.btoa(data.id)}?type=evet_stage`);
            // } else if (type == "edit") {
            //   navigate(`/events/edit/${window.btoa(data.id)}?type=evet_stage&job_id=${(id)}`);
            // }
          }}
          style={{ fontWeight: "bold", color: "#1890ff", cursor: "pointer" }}
        >
          {text}
        </Typography.Link>
      )
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (data) => (
        <Space size="middle">
          <Tooltip title="Edit">
            <Button
              shape="circle"
              className="border-0"
              icon={<EditOutlined style={{ color: "blue" }} />}
              onMouseDown={(e) => {
                if (type == "add") {
                  e.preventDefault();
                  handleJobSave(data.id);
                } else if (type == "edit") {
                  navigate(`/events/edit/${window.btoa(data.id)}?type=evet_stage&job_id=${(id)}`);
                }

              }}
            />
          </Tooltip>

          <Tooltip title="Delete">
            <Button
              shape="circle"
              danger
              icon={<DeleteOutlined />}
              onMouseDown={(e) => {
                e.preventDefault();
                handleEventRemove(data.id);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: "Select Final Stage",
      key: "final_stage",
      align: "center",
      render: (data) => {
        // find the latest state for this row (important if table data is not auto-refreshed)
        const row = selectedEvents.find((e) => e.id === data.id) || data;

        return (
          <Tooltip title="Select Final Stage for this Spec">
            <Checkbox
              // use onMouseDown since dnd-kit eats onChange
              onMouseDown={() =>
                CheckboxOnchange(data.id, row?.is_last_stage === 1)
              }
              checked={row?.is_last_stage === 1}
            />
          </Tooltip>
        );
      },
    },
  ];

  return (
    <div>
      <Loader loading={jobLoading} />
      <PageHeader
        HeaderText="Job Spec"
        Breadcrumb={[{ name: "Job Spec" }]}
        backButtonUrl="/jobs"
      />
      <Card title={type === "add" ? "Add Job Spec" : "Edit Job Spec"}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row gutter={[16, 16]} className="p-4">
            {/* First Row of Input Fields */}
            <Row gutter={[16, 16]} style={{ width: '100%' }}>
              <Col xs={24} sm={12} md={8}>
                <TextInput
                  name="job_name"
                  control={control}
                  label="Job Name"
                  placeholder="Enter Job Name"
                  errors={errors}
                  required={true}
                />
              </Col>
              <Col xs={24} sm={12} md={8}>
                <TextInput
                  name="spec_id"
                  control={control}
                  label="Spec ID"
                  placeholder="Enter your spec ID"
                  errors={errors}
                  required={true}
                  disabled={type == "edit" ? true : false}
                />
              </Col>
              <Col xs={24} sm={12} md={8}>
                <SelectInput
                  name="customer_id"
                  control={control}
                  label="Customer"
                  placeholder="Select customer"
                  options={customerList}
                  errors={errors}
                  required={true}
                />
              </Col>
            </Row>

            {/* Second Row of Input Fields */}
            <Row gutter={[16, 16]} style={{ width: '100%' }}>
              <Col xs={24} sm={12} md={8}>
                <SelectInput
                  name="status"
                  control={control}
                  label="Status"
                  placeholder="Select Status"
                  options={[
                    { label: "Awaiting Review", value: 1 },
                    { label: "Yet to Start", value: 2 },
                    { label: "In Progress", value: 3 },
                    { label: "Completed", value: 4 },
                    { label: "Return to Customer", value: 5 },
                  ]}
                  errors={errors}
                  required={true}
                  disabled={!watchWorkflow ? true : false}
                />
              </Col>
              <Col xs={24} sm={12} md={8}>
                <SelectInput
                  name="to"
                  control={control}
                  label="Project Manager"
                  placeholder="Select manager"
                  options={managerList}
                  errors={errors}
                />
              </Col>
              <Col xs={24} sm={12} md={8}>
                <SelectInput
                  name="original_disposition"
                  control={control}
                  label="Original Disposition"
                  placeholder="Select disposition"
                  options={[
                    { label: "Return", value: 1 },
                    { label: "Hold", value: 2 },
                    { label: "Destruction", value: 3 },
                  ]}
                  errors={errors}
                />
              </Col>
            </Row>

            {/* Third Row - Disposition Days */}
            <Row gutter={[16, 16]} style={{ width: '100%' }}>
              <Col xs={24} sm={12} md={8}>
                <TextInput
                  name="disposition_day"
                  control={control}
                  label="Disposition Days"
                  placeholder="Enter disposition"
                  errors={errors}
                />
              </Col>
              <Col xs={24} sm={12} md={8}>
                <SelectInput

                  name="delivery_type"
                  control={control}
                  label="Type of Delivery"
                  placeholder="Select Delivery Type"
                  options={[
                    { label: "SFTP", value: 1 },
                    { label: "HARD DRIVE", value: 2 },
                    { label: 'OTHER', value: 3 }
                  ]}
                  errors={errors}
                  required={true}
                />
              </Col>
            </Row>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingRight: '30px', marginLeft: '400px' }}>
              <Button
                shape="round"
                style={{ marginBottom: "30px" }}
                className="primary-btn"
                icon={<FileDoneOutlined />}
                htmlType="submit"
                onClick={handleSubmit(onSubmit)}
              > {type === "add" ? "Add Job Spec" : "Update Job Spec"}
              </Button>
            </div>


            {/* Events Section */}
            <Divider style={{ margin: '24px 0' }} />

            <Row style={{ width: '100%', marginBottom: 16 }}>
              <Col span={24}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h6><b >Select Box Event Stages for this Spec</b></h6>
                  <Button
                    className="primary-btn"
                    type="primary"
                    onClick={handleShowEvents}
                  >
                    {!showEvents ? "Show Events" : 'Hide Events'}
                  </Button>
                </div>
              </Col>
            </Row>

            {showEvents && (
              <>
                {/* Pagination Controls */}
                <Row justify="end" style={{ width: '100%', marginBottom: 16 }}>
                  <Col>
                    {paginatedEvents.length > 0 && (
                      <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={eventData.length}
                        onChange={handlePageChange}
                      />
                    )}
                  </Col>
                </Row>

                {/* Events Grid */}
                <Row gutter={[16, 16]} style={{ width: '100%' }}>
                  {paginatedEvents.length > 0 ? (
                    paginatedEvents.map((event) => {
                      const isDuplicate = selectedEvents.some(
                        (selected) => selected.eventname === event.eventname
                      );
                      const isHighlighted = highlightedEvents.find(
                        (highlighted) => highlighted.id === event.id
                      );

                      return (
                        <Col xs={24} sm={12} md={8} lg={6} key={event.id}>
                          <Card
                            bordered
                            hoverable
                            onClick={() => handleEventSelect(event)}
                            style={{
                              backgroundColor: isDuplicate
                                ? "#ffcccc"
                                : isHighlighted
                                  ? "#e6f7ff"
                                  : "#ffffff",
                              fontWeight: "bold",
                              height: "100%",
                              minHeight: "80px",
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                            }}
                          >
                            {event?.eventname}
                          </Card>
                        </Col>
                      );
                    })
                  ) : (
                    <Col span={24} style={{ textAlign: 'center', padding: '20px' }}>
                      <Typography.Text>No data found</Typography.Text>
                    </Col>
                  )}
                </Row>

                {/* OK Button */}
                <Row justify="center" style={{ width: '100%', marginTop: 24 }}>
                  <Col span={3}>
                    <Button
                      className="primary-btn"
                      type="primary"
                      shape="round"
                      onClick={handleShowEvents}
                    >
                      {!showEvents ? "" : 'Hide Events'}
                    </Button>
                  </Col>
                  <Col span={4}>
                    <Button
                      className="primary-btn"
                      type="primary"
                      shape="round"
                      onClick={handleAddSelectedEvents}
                    >
                      Select
                    </Button>
                  </Col>

                </Row>
              </>
            )}
          </Row>
        </form>
      </Card>
      <DndContext collisionDetection={closestCenter} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
        <SortableContext items={selectedEvents.map((item) => item?.id)} strategy={verticalListSortingStrategy}>
          <Table style={{ marginBottom: "30px" }} rowKey="id" components={{ body: { row: SortableRow } }} columns={columns} dataSource={selectedEvents} pagination={false} />
        </SortableContext>
      </DndContext>
      {
        selectedEvents.length > 0 && (
          <>
            <Flex gap="small" justify="center">
              <Button
                shape="round"
                style={{ marginBottom: "30px" }}
                className="primary-btn"
                icon={<FileDoneOutlined />}
                htmlType="submit"
                onClick={handleSubmit(onSubmit)}
              >
                {type === "add" ? "Update Event Stages" : "Update Event Stages"}
              </Button>
            </Flex>
          </>
        )
      }
    </div>
  );
};

export default AddEditJobs;
